export const DEFAULT_CLOUDFLARE_PREVIEW_BACKEND_URL = "https://api.dev.moogli.io"

export function isCloudflarePagesHostname(hostname: string): boolean {
  return hostname === "pages.dev" || hostname.endsWith(".pages.dev")
}

export function resolvePagesBackendUrl(configuredBackendUrl: string | undefined, hostname: string): string | undefined {
  const backendUrl =
    configuredBackendUrl || (isCloudflarePagesHostname(hostname) ? DEFAULT_CLOUDFLARE_PREVIEW_BACKEND_URL : undefined)

  return backendUrl?.replace(/\/+$/, "")
}
